// extracted by css-extract-rspack-plugin
export default {"fixation":"Sidebar__fixation--yKXF9","menuBtn":"Sidebar__menuBtn--ppthN","itemWrap":"Sidebar__itemWrap--gNvHp","itemRightIcon":"Sidebar__itemRightIcon--PEIUY"};